Monitoring.Views ||= {}

class Monitoring.Views.RulesView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/rules"]

  events :
    'click #new-rule': 'onClickNewRule'

  initialize: (@options = {}) ->
    @rules              = @options.rules
    @availableTopics    = @options.available_topics
    @availableTags      = @options.available_tags
    @availableGroups    = @options.available_groups
    @availableSubtypes  = @options.available_subtypes
    @allSubtypes        = @options.all_subtypes
    @availableUserProfileTags = @options.available_user_profile_tags
    @availableUserGroups    = @options.available_user_groups || []
    @availableOperators   = @options.available_operators || []
    @availableTicketStatuses  = @options.available_ticket_statuses || []
    @availableTemplates = @options.available_templates || []
    @currentUser          = @options.current_user
    @action_type          = @options.action_type
    @noOtherTags          = @options.noOtherTags
    @newsFilterAllowed    = @options.newsFilterAllowed
    @showLocation         = @options.showLocation

  render: =>
    @listView.remove() if @listView
    @editView.remove() if @editView
    @$el.html(@template(@))
    @renderList()
    @

  renderList: =>
    @listView.remove() if @listView
    listData = {
      rules: @rules
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @allSubtypes
      availableUserProfileTags: @availableUserProfileTags
      availableUserGroups: @availableUserGroups
      availableOperators: @availableOperators
      availableTicketStatuses: @availableTicketStatuses
      availableTemplates: @availableTemplates
      currentUser: @currentUser
      availableSentiments: @availableSentiments()
      availableModerationDecision: @availableModerationDecision()
    }
    @listView = @ruleListView(listData)
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'edit', @renderEdit)

  onClickNewRule: ->
    @renderEdit()

  renderEdit: (rule) ->
    rule = @defaultNewRule() unless rule
    @editView.remove() if @editView
    editOptions = {
      rule: @clonedRule(rule)
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @availableSubtypes
      availableUserProfileTags: @availableUserProfileTags
      availableUserGroups: @availableUserGroups
      availableOperators: @availableOperators
      availableTicketStatuses: @availableTicketStatuses
      availableTemplates: @availableTemplates
      currentUser: @currentUser
      availableSentiments: @availableSentiments()
      action_type: @action_type
      availableModerationDecision: @availableModerationDecision()
      noOtherTags: @noOtherTags
      newsFilterAllowed: @newsFilterAllowed
      showLocation: @showLocation
    }
    @editView = @newEditView(editOptions)
    @$el.find('.edit-view-container').html(@editView.render().el)
    @listenTo(@editView, 'cancel', @render)
    @listenTo(@editView, 'afterSave', @afterSave)

  defaultNewRule: ->
    if @action_type == 'social_content_action'
      new Monitoring.Models.ContentRule
    else if @action_type == 'ticket_action'
      new Monitoring.Models.TicketRule
    else
      new Monitoring.Models.ProfileRule

  newEditView: (options) =>
    if @action_type == 'ticket_action'
      new Monitoring.Views.TicketRuleEditView(options)
    else
      new Monitoring.Views.RuleEditView(options)

  ruleListView: (data) =>
    if @action_type == 'ticket_action'
      new Monitoring.Views.TicketRuleListView(data)
    else
      new Monitoring.Views.RuleListView(data)

  afterSave: (newRule) ->
    @rules.add(newRule, {merge: true})
    @rules.sort() if @action_type == 'ticket_action'
    @render()

  availableSentiments: ->
    _.map(['negative', 'neutral', 'positive', 'missing', 'no_sentiment'], (s) ->
      {
        name: I18n.t('monitoring.rules.sentiments.' + s)
        code: s
      }
    )

  availableModerationDecision: ->
    ['Rejected', 'Approved', 'Unknown']

  clonedRule: (rule) =>
    newRule = rule.clone()
    newRule.set('social_content_condition', $.extend(true, {}, rule.get('social_content_condition')))
    newRule.set('actions', $.extend(true, {}, rule.get('actions')))
    if @action_type == 'ticket_action'
      newRule.set('ticket_condition', $.extend(true, {}, rule.get('ticket_condition')))
    newRule
